export default __webpack_public_path__ + "static/media/banner_tienlen_HIRING_PC.fc174888.png";